import { createClient } from '@supabase/supabase-js'

const SB_URL = 'https://efvgrxgtjdsarvibjkap.supabase.co'
const SB_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVmdmdyeGd0amRzYXJ2aWJqa2FwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2NTMyNzAsImV4cCI6MjA5MDIyOTI3MH0.kl6gmqrHyz0vh0UVU1dsr0g--HMk8hSu03Er7YiX9w4'
export const BUCKET = 'fotos-obras'

export const supabase = createClient(SB_URL, SB_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
})
